<mat-toolbar class="expanded-toolbar" color="primary">
  <div class="sidenav-content">
    <button
      (click)="onToggleSidenav()"
      aria-label="Menü öffnen"
      class="example-icon"
      mat-icon-button
    >
      <mat-icon>menu</mat-icon>
    </button>
    <span>AB/RE-Portal</span>
  </div>

  <!-- Profilbild und Logo rechtsbuendig, Bild links vom Zeichen - exakt die
       Anordnung aus Kalkulationstool und Einschreiben-Werkzeug. Der Klarname
       steht nicht mehr daneben; er haengt als Kurzhinweis am Bild. -->
  <div class="brand-block">
    <div class="user-avatar" [title]="user?.name || 'Angemeldeter Benutzer'">
      <img
        *ngIf="avatarUrl"
        class="user-avatar-image"
        [src]="avatarUrl"
        alt="Profilbild"
        (error)="onAvatarError()"
      />
      <span class="user-avatar-initials" *ngIf="!avatarUrl">{{ initials }}</span>
    </div>
    <img alt="Muessig" src="assets/img/logos/logo.png" />
  </div>

</mat-toolbar>
